import React from 'react';

import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import type { NewCoreIconProps } from '@atlaskit/icon/base-new';
import { token } from '@atlaskit/tokens';

export const QuickSummaryIcon = (props: NewCoreIconProps): React.JSX.Element => (
	<AtlassianIntelligenceIcon color={token('color.icon')} {...props} />
);
